<template>
  <div>
    <b-modal
      id="modalVMSOffline"
      title="ข้อมูลเพิ่มเติมจุดติดตั้งป้าย (ใช้ไม่ได้)"
      size="lg"
      ok-title="กลับ"
      ok-only
    >
      <b-row>
        <b-col cols="12">
          <b-table
            responsive
            :per-page="perPage"
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
            :borderless="borderless"
          >
            <!-- <template #cell(detail)="data">
              <b-link
                v-b-modal="'modalAnalytic'"
                title="กดเพื่อดูเพิ่มเติม"
                style="color: #11DF00;"
                @click="$refs.childref.getModalTableAnalytic(data.item.WID ,items1[data.index].detail)"
              >
                <u>{{ items1[data.index].detail }}</u>
              </b-link>
            </template> -->
            <template #cell(anydesk)="data">
              <a :href="`anydesk:${data.value}`">
                <b-button
                  size="sm"
                  variant="outline-danger"
                ><b-img
                  src="@/assets/images/logo/anydesk.png"
                  style="height: 16px; width: 16px;"
                /> <span style="color:#fff;"> {{ data.value }}</span></b-button>
              </a>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <ModalAnalytic
        ref="childref"
      />
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BTable, BImg,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BImg,
    // BLink,
  },
  data() {
    return {
      fields: [
        {
          key: 'detail',
          label: 'จุดติดตั้ง',
          sortable: false,
        },
        {
          key: 'lastupdate',
          label: 'อัพเดตล่าสุด',
          sortable: false,
          class: 'text-center',
        },
        {
          key: 'anydesk',
          label: 'Anydesk',
          sortable: false,
          class: 'text-center',
          tdClass: 'bg-light-danger',
        },
      ],
      items: [],
      perPage: 1000,
      sortBy: '',
      sortDesc: false,
      borderless: true,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    computedFields() {
      // If the user isn't an admin, filter out fields that require auth.
      if (this.userData.role === 'User') return this.fields.filter(field => !field.requiresAdmin)
      return this.fieldsSpeaker
    },
  },

  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getVMSOfflineTotal()
    this.interval = setInterval(() => {
      this.getVMSOfflineTotal()
    }, 300000)
  },
  methods: {
    getVMSOfflineTotal() {
      axios
        .post('/getVMSOffline')
        .then(response => {
          this.items = response.data
          this.totalRows = response.data.length
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.text3 {
    font-family: 'Sarabun';
    font-size: 16px;
    color: #fff;
  }
</style>
